export const getTranslatedErrorMessage = (message: string) => {
    switch (message){
        case 'Invalid cucle value':
        case 'Invalid cycle value':
            return 'Der angegebene Zyklus ist nicht gültig. Gültig sind 2 oder 3.'
        case 'Given MeasureType not exist':
            return 'Der angegebene Maßnahmentyp existiert nicht.'
        case 'Name cannot be empty':
            return 'Der Name fehlt.'
        case 'ImplementationStatus cannot be empty':
            return 'Der Implementierungsstatus fehlt.'
        case 'Given point is outer the layer boundary':
            return 'Die Maßnahme liegt außerhalb des angegebenen Zuständigkeitsbereiches.'
        case 'Not permission to create measure point':
            return 'Das Recht zum Melden von Maßnahmen fehlt. Bitte überprüfen Sie Ihre Anmeldedaten (Email und Passwort).'
        case 'Name is too long':
            return 'Die Kurzbezeichnung darf nicht länger als 200 Zeichen sein.'
        case 'Description is too long':
            return 'Die Beschreibung darf nicht länger als 2700 Zeichen sein.'
        default:
            return message
    }
}